var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaPowerball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M41.8 6.21c4.46 0 8.08 3.64 8.08 8.13s-3.62 8.13-8.08 8.13-8.08-3.64-8.08-8.13 3.62-8.13 8.08-8.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M27.073 42.365c3.852 0 6.984 3.15 6.984 7.03s-3.122 7.03-6.984 7.03-6.984-3.15-6.984-7.03 3.132-7.03 6.984-7.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.711 58.032h36.636v4.452H58.711z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.317 58.346h14.725v3.824H80.317z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.223 58.688c1.339-.028 2.235-.111 2.235 1.025 0 .924-1.145.878-1.866.878v1.45h-.37v-3.353zm.379.323v1.247c.536 0 1.515.148 1.469-.665-.037-.73-.998-.582-1.469-.582zm2.716-.434h.37v3.058h1.349v.277H84.31v-3.335zm3.981 0h.471l1.45 3.344h-.37l-.453-1.044H87.67l-.443 1.044h-.37l1.441-3.344zm.951 1.958-.711-1.654-.711 1.654h1.423zm1.478-1.857h.379l1.016 1.7 1.016-1.7h.379l-1.21 2.032v1.312h-.37V60.71z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.829 58.651h1.931c.628.074.942.48.942 1.081 0 1.09-1.035 1.053-1.811 1.044v1.266h-1.053v-3.39zm1.053.702v.711c.268 0 .776.055.776-.333.018-.462-.462-.379-.776-.379zm15.768-.73h2.005c1.164 0 1.395 1.552.323 1.903.443.185.831 1.072.97 1.496h-1.182c-.148-.277-.628-1.293-.822-1.367-.037-.018-.166-.009-.231-.009v1.367H76.66v-3.39zm1.053.684v.674c.323 0 .915.018.915-.314.009-.379-.545-.36-.915-.36zm-10.309-.684h.979l.351 1.848.517-1.848h.933l.517 1.848.351-1.848h.979l-.702 3.362h-1.016l-.591-2.041-.591 2.041h-1.016l-.711-3.362zm6.577.73v.517h1.607v.721h-1.607v.665h1.755v.757h-2.799v-3.381h2.78v.721H73.97zm-8.951-.859h.249c2.189 0 2.189 3.519 0 3.519h-.249c-2.189 0-2.189-3.519 0-3.519zm.841 1.524v.471a.67.67 0 0 1-.693.702c-.36.009-.73-.231-.73-.702v-.471c0-.48.36-.721.721-.711.351.009.702.24.702.711z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#281f0f"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.358 58.623c.323 0 .591.268.591.591a.591.591 0 0 1-.591.591.595.595 0 0 1-.591-.591.601.601 0 0 1 .591-.591zm0 .129a.471.471 0 1 1-.471.471.48.48 0 0 1 .471-.471z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.109 59.538h.139v-.24c.102 0 .083.046.194.24h.194l-.176-.277c.092-.037.139-.111.139-.185 0-.203-.342-.157-.49-.157v.619zm.139-.36v-.157c.212-.055.268.194 0 .157zM4.856 40.619h.425v-2.402l.896 2.402h.37l.915-2.466v2.466h.379v-3.011h-.554l-.924 2.494-.924-2.494h-.573v3.011zm4.249-3.011h.425v3.011h-.425zm5.312 3.011h.425V39.28h1.515v1.339h.425v-3.011h-.425v1.293h-1.515v-1.293h-.425zm10.614-1.247h-1.025l.517-1.386.508 1.386zm-.748-1.764-1.118 3.011h.379l.333-.915h1.275l.342.915h.379l-1.118-3.011h-.471zm-1.949 1.386h-1.33v.379h.942c-.018.573-.425.961-.933.961-.711 0-1.007-.702-.998-1.238.009-.591.36-1.21.998-1.21a.841.841 0 0 1 .85.674h.416c-.083-.684-.647-1.044-1.275-1.044-1.894 0-1.921 3.196 0 3.196.37 0 .711-.176.933-.416l.111.314h.268l.018-1.617zm4.443 1.626h.425v-2.383l1.515 2.383h.48v-3.011h-.425v2.439l-1.543-2.439h-.453v3.011zm-8.72-3.011h.425v3.011h-.425zm-6.023-.092c.61 0 1.109.416 1.275.998h-.443c-.12-.37-.425-.628-.831-.628-.619 0-.97.619-.979 1.21 0 .536.277 1.238.979 1.238.49 0 .85-.388.878-.859h.443c-.065.693-.619 1.238-1.321 1.238-1.894 0-1.866-3.196 0-3.196z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.502 42.134c3.981 0 7.214 3.252 7.214 7.261s-3.233 7.261-7.214 7.261-7.214-3.252-7.214-7.261 3.233-7.261 7.214-7.261z",
    fill: "#dd1436"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.821 46.67s-.379 1.118-.379 2.605.388 2.485.388 2.485l1.552.157c.286-.009.859-.074.905-1.062.018-.425-.028-1.598-.573-1.764 0 0 .462-.406.48-1.367s-.425-1.118-.951-1.118l-1.423.065zm.684 1.192s-.092.314-.129.859h.351c.185 0 .277-.018.379-.148.074-.102.139-.453.065-.591-.065-.111-.231-.185-.665-.12zm-.12 1.801c.037.637.111.97.111.97h.508s.323.018.305-.379a.563.563 0 0 0-.139-.397c-.139-.176-.277-.176-.462-.185l-.323-.009zm2.06 2.143c.009-.379.055-1.099.305-2.226.268-1.219.748-2.374 1.025-2.993h1.256l1.302 5.312h-1.201l-.194-.748H86.71l-.046.711-1.219-.055zm2.226-1.755c-.111-.462-.388-1.478-.388-1.857 0 0-.268.905-.434 1.857h.822zm2.023-3.455.092 3.095-.083 2.199 2.707-.092c.092-.36.212-1.182.212-1.182l-1.644.009.046-1.617a17.385 17.385 0 0 0-.157-2.402c-.37 0-.767 0-1.173-.009zm3.002.074a8.84 8.84 0 0 1 .277 2.494 17.356 17.356 0 0 1-.305 2.633l1.931-.083.416-1.182h-1.182c.129-1.45.139-2.346-.185-3.797l-.951-.065z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.747 41.848c4.12 0 7.464 3.362 7.464 7.51s-3.344 7.51-7.464 7.51-7.464-3.362-7.464-7.51 3.344-7.51 7.464-7.51z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.747 42.337c3.852 0 6.984 3.15 6.984 7.03s-3.122 7.03-6.984 7.03-6.984-3.159-6.984-7.039 3.122-7.021 6.984-7.021z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.828 53.616c-.406-2.457-.48-6.189.222-8.563l3.732-.037c1.238.083 2.707.582 3.224 1.829.36.887.397 1.931-.055 2.716-.915 1.58-2.919 1.46-4.462 1.45l.028 2.614c0-.009-2.023.092-2.688-.009zm2.633-4.785.046-1.737s.721-.046 1.21.028c1.266.185 1.164 1.478.009 1.69-.443.074-1.266.018-1.266.018z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05 53.376c-.379-2.328-.453-5.866.212-8.12l3.492-.037c1.155.074 2.54.545 3.011 1.727.342.841.379 1.829-.055 2.577-.859 1.496-3.011 1.275-4.452 1.275l.028 2.577c-.009 0-1.617.092-2.235 0zm2.171-4.295.055-2.235s.887-.065 1.487.028c1.57.24 1.441 1.903.009 2.171-.536.102-1.552.037-1.552.037z",
    style: {
      fill: "#001627"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.073 41.885c4.12 0 7.455 3.362 7.455 7.51s-3.335 7.51-7.455 7.51-7.464-3.362-7.464-7.51c.009-4.148 3.344-7.51 7.464-7.51z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.073 44.767c2.439 0 4.416 1.995 4.416 4.452s-1.977 4.452-4.416 4.452-4.416-1.995-4.416-4.452 1.977-4.452 4.416-4.452zm0 2.217c.951 0 1.506.998 1.506 2.226s-.536 2.226-1.506 2.226-1.506-.998-1.506-2.226.554-2.226 1.506-2.226z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.073 44.998c2.309 0 4.194 1.894 4.194 4.222s-1.875 4.222-4.194 4.222-4.194-1.884-4.194-4.222 1.875-4.222 4.194-4.222zm0 1.746c.97 0 1.755 1.109 1.755 2.476s-.785 2.476-1.755 2.476-1.755-1.109-1.755-2.476.785-2.476 1.755-2.476z",
    style: {
      fill: "#001627"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 35.005,
    x: 4.101,
    transform: "translate(.025 3.812) scale(.9238)",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.434 42.374c3.852 0 6.984 3.15 6.984 7.03s-3.132 7.03-6.984 7.03-6.984-3.15-6.984-7.03 3.122-7.03 6.984-7.03z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.862 45.229c-.139.6-.48 2.309-.055 4.028.379 1.543 1.136 3.39 1.598 4.369l2.226.018.333-2.42.434-2.226s.6 2.503.721 4.646l2.476-.046c.268-.536.942-1.995 1.496-4.212.48-1.912.268-3.362.083-4.111-.536-.046-1.275-.046-2.115-.065a12.933 12.933 0 0 1-.453 4.462l-1.09-4.517h-2.134L40.19 49.7c-.249-1.21-.517-3.196-.351-4.499l-1.977.028z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.139 45.441c-.139.573-.443 2.189-.055 3.824.351 1.469 1.072 3.224 1.496 4.148l1.866.018.841-5.016c.083-.037.203-.009.203-.009s.748 2.984.859 5.016l2.051-.046c.249-.508.878-1.894 1.404-4 .453-1.811.259-3.187.083-3.898-.508-.046-.859-.046-1.644-.065.111 1.367-.166 3.667-.545 4.868a.449.449 0 0 1-.231.009l-1.025-4.933-2.005.009-1.127 4.905a.63.63 0 0 1-.222.009c-.24-1.145-.6-3.63-.443-4.868l-1.506.028z",
    style: {
      fill: "#001627"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 20.721,
    y: 35.005,
    transform: "translate(.025 3.812) scale(.9238)",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.778 42.365c3.852 0 6.984 3.15 6.984 7.03s-3.122 7.03-6.984 7.03-6.984-3.15-6.984-7.03 3.122-7.03 6.984-7.03z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.739 45.183c-.684 2.54-.582 5.681-.018 8.231 2.106.342 4.222.305 6.337.028.259-.573.397-1.506.416-2.134-1.339.157-2.845.185-4.194.129l-.028-1.09 3.455-.009.009-2.152-3.464-.018.009-.998 4.092.046c-.129-.693-.277-1.376-.554-2.023 0 .009-3.113-.425-6.06-.009z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.933 45.441c-.647 2.383-.545 5.321-.018 7.723 1.986.323 3.972.314 5.958.055.249-.536.305-1.053.323-1.644-1.266.148-2.901.157-4.175.102l-.009-1.598 3.473.009-.018-1.672-3.436-.028v-1.45l4.028.055c-.12-.647-.166-.933-.425-1.543.009.009-2.919-.397-5.7-.009z",
    style: {
      fill: "#001627"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 37.331,
    y: 35.005,
    transform: "translate(.025 3.812) scale(.9238)",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 46.048,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.861 53.478s-.684-1.801-.536-4.314.757-4.046.757-4.046.896-.24 2.753-.24c1.848 0 3.242.314 3.871 1.349s.527 2.171.111 2.67c-.416.508-.831.647-.831.647s1.081.351 1.21 1.33c.12.979-.166 1.875-.185 1.995s-.009.157-.009.157l.166-.028-.074.471-1.561.148-1.09.028s-.148-.249-.083-.979c.055-.721.028-1.57-.333-1.829-.37-.268-1.053-.24-1.219-.24l-.499.009.055 3.03c0 .018-1.432.139-2.503-.157zm2.439-4.831.037-1.478c.702-.046 2.032-.203 2.143.702.111.988-1.533.804-2.18.776z",
    style: {
      fill: "#281f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.045 53.284c-.776-2.429-.573-5.561.24-7.972 1.552-.333 4.961-.453 6.088.859 1.099 1.275.684 3.048-1.118 3.381 3.122.813 1.025 3.335 1.617 3.732-.739.074-1.487.148-2.235.111 0 0-.092-.748-.037-1.266.046-.517-.055-1.367-.628-1.58-.582-.212-1.884-.148-1.884-.148l.055 3.03c-.009 0-1.062.083-2.097-.148zm1.995-4.369.046-1.977c.868-.055 2.513-.277 2.642.933.148 1.321-1.884 1.072-2.688 1.044z",
    style: {
      fill: "#001627"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaPowerball);
export default __webpack_public_path__ + "static/media/usa_powerball.13ff02d21fa34ddefddea58b31095711.svg";
export { ForwardRef as ReactComponent };